<script>
	export let text = '';
	export let secondary = false;
	export let margins = false;
	export let smaller = false;
	export let larger = false;
	export let width = '100%';
	export let height = 'auto';
	export let icon = '';
	export let disabled = false;
	export let link = false;
	export let audioButton = false;
</script>

{#if link}
	<a
		href={link}
		{...$$restProps}
		class:secondary
		class:margins
		class:smaller
		class:larger
		class:disabled
		class:audioButton
		class="bg-theme_amber rounded-3xl border-4 border-theme_white text-theme_white px-5 py-1 mx-auto text-lg sm:text-xl font-semibold text-center {icon
			? 'flex gap-2 justify-center items-center'
			: 'block'}"
		style="width:{width}; height:{height}"
	>
		{#if icon}
			<img src={icon} alt="" />
		{/if}
		{text}
	</a>
{:else}
	<button
		on:click
		{...$$restProps}
		class:secondary
		class:margins
		class:smaller
		class:larger
		class:audioButton
		class="bg-theme_amber rounded-3xl border-4 border-theme_white text-theme_white px-5 py-1 mx-auto text-lg sm:text-xl font-semibold {icon
			? 'flex gap-2 justify-center items-center'
			: 'block'}"
		style="width:{width}; height:{height}"
		{disabled}
	>
		{#if icon}
			<img src={icon} alt="" />
		{/if}
		{text}
	</button>
{/if}

<style>
	.secondary {
		@apply bg-theme_white border-theme_amber text-theme_amber;
	}

	button,
	a {
		box-shadow: 0 8px 12px 0 rgb(0 0 0 / 0.2);
	}

	button[disabled],
	a.disabled {
		opacity: 0.7;
		cursor: not-allowed;
		box-shadow: none;
		pointer-events: none;
	}

	button:not([disabled]):hover,
	a:not(.disabled):hover {
		background-color: theme(colors.theme_darkbrown);
	}

	button.secondary:not([disabled]):hover,
	a.secondary:not(.disabled):hover {
		background-color: theme(colors.theme_lightgray);
	}

	.margins {
		@apply !mt-auto mb-4;
	}

	.smaller {
		@apply text-sm border-2 gap-1 px-3;
	}

	.larger {
		@apply text-lg px-1 py-1 rounded-full;
	}

	img {
		max-width: 24px;
		max-height: 24px;
	}

	.smaller img {
		max-width: 18px;
		max-height: 18px;
	}

	.larger img {
		width: 24px;
		height: 24px;
	}
</style>
